// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Y45wK","title":"Header_title__3wk0c","side":"Header_side__K5lpf"};